import axios from 'axios';
import { EmailNotificationsListItem } from 'types';

export const fetchEmailNotifications = (brandId: number) =>
  axios.get<EmailNotificationsListItem[]>(
    `/api/brands/${brandId}/email_notifications`
  );
